import React from 'react';
import EnhancedModal from '@components/generic-modal/EnhancedModal';
import PolicyPersonPopUp from './PolicyPersonPopUp';
import { IPersonWidgetInfo } from '@modules/production/policy/page/tabs/policy-persons-tab';

interface IPolicyPersonPopUpShellProps {
  open: boolean;
  section: string;
  lineExternalCode: string;
  maxInsured: number;
  data: IPersonWidgetInfo[];
  lovs: Record<string, Record<string, string>>;
  onClose: () => void;
  onSuccess: () => void;
}

const PolicyPersonPopUpShell: React.FC<IPolicyPersonPopUpShellProps> = ({
  open,
  section,
  lineExternalCode,
  data,
  lovs,
  maxInsured,
  onClose,
  onSuccess,
}) => {
  return (
    <EnhancedModal
      open={open}
      blur={true}
      onClose={onClose}
      title={
        section === 'insured'
          ? 'Modify Insured popup'
          : 'Modify Beneficiary popup'
      }
    >
      <PolicyPersonPopUp
        data={data}
        lovs={lovs}
        onClose={onClose}
        onSuccess={onSuccess}
        lineExternalCode={lineExternalCode}
        section={section}
        maxInsured={maxInsured}
      />
    </EnhancedModal>
  );
};

export default PolicyPersonPopUpShell;
